import { useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import { useActions } from 'hooks/actions';
import { useIsExisting } from 'pages/audience/shared/save/hooks';
import { SaveAndCloseButtonProps, SaveForm } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities/strings';

export const useSaveCloseButtonConfiguration = ({
  requireChanges = true,
}: Pick<SaveAndCloseButtonProps, 'requireChanges'>) => {
  const { dispatch } = useActions();
  const {
    formState: { isDirty, isValid },
    reset,
  } = useFormContext<SaveForm>();
  const isExisting = useIsExisting();

  const handleReset = useCallback(() => reset(), [reset]);

  const handleSave = useCallback(() => dispatch('save'), [dispatch]);

  const handleSaveAndRun = useCallback(() => dispatch('save-and-run'), [dispatch]);

  return {
    handleReset,
    handleSave,
    handleSaveAndRun,
    isDirty,
    isDisabled: requireChanges && (!isValid || !isDirty),
    saveAndCloseLabel: isExisting ? s('Site.UpdateAndRun') : s('Site.SaveAndRun'),
    saveLabel: isExisting ? s(['Site.Update']) : s(['Site.Save']),
  };
};
